import React from 'react';
import { motion } from 'framer-motion';

const InvitationError = ({ message }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-cream px-8">
      <motion.div
        className="max-w-2xl text-center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="text-6xl mb-6">😔</div>
        <h1 className="text-4xl md:text-5xl font-display mb-6 text-charcoal">
          Invitation Not Found
        </h1>
        <div className="w-20 h-px bg-gold mx-auto mb-6" />
        <p className="text-lg text-sage-dark mb-8 leading-relaxed">
          {message || 'We couldn\'t find your invitation. Please check your invitation link or contact the couple.'}
        </p>
        <div className="bg-white p-6 rounded-lg shadow-lg border-l-4 border-sage">
          <p className="text-charcoal mb-4">
            <strong>Common Issues:</strong>
          </p>
          <ul className="text-left text-sage-dark space-y-2">
            <li>• The invitation link may be incomplete</li>
            <li>• The invitation code might have expired</li>
            <li>• You may have received the link incorrectly</li>
          </ul>
        </div>
        <div className="mt-8">
          <p className="text-sm text-sage-dark">
            Need help? Please contact Caleb & Alyssa directly.
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default InvitationError;
